import RHFDictionary from '../RHFDictionary';
import { useStorages } from 'iomart-hooks';
import type { Columns } from 'src/@types/common';

const DICTIONARY_COLUMNS: (Columns & { minWidth?: number; maxWidth?: number })[] = [
  {
    name: 'name',
    subname: 'description',
    label: 'Name',
    align: 'left',
    nameLines: 2,
    subNameLines: 1,
    minWidth: 160,
    width: 240,
    maxWidth: 320,
  },
];

type RHFStorageProps = {
  name: string;
  label?: string;
  multiple?: boolean;
  disabled?: boolean;
  /** Фильтр: только с синхронизацией */
  withSync?: boolean;
  /** Ширина Drawer справочника */
  drawerWidth?: Record<string, string | number>;
};

export default function RHFStorage({
  name,
  label = 'Storage',
  multiple = false,
  disabled,
  withSync,
  drawerWidth = { xs: '100%', sm: 480 },
}: RHFStorageProps) {
  const filters = withSync === true ? { withSync: true } : {};

  return (
    <RHFDictionary
      name={name}
      label={label}
      useHook={useStorages}
      columns={DICTIONARY_COLUMNS}
      multiple={multiple}
      optionsLabel="name"
      getOptionLabel={(opt: any) => opt?.name || `#${opt?.id}` || ''}
      searchName="name"
      pageSize={10}
      disabled={disabled}
      filters={filters}
      drawerWidth={drawerWidth}
    />
  );
}
